import { Pipe, PipeTransform } from '@angular/core';
import {
  EMPTY_VALUE,
  FAX_NUMBER_FORMAT,
  FAX_NUMBER_FORMATTED_REGEXP,
  FAX_NUMBER_MASK_REGEXP,
  ONLY_DIGITS_REGEXP,
} from '../constants';

@Pipe({
  name: 'faxNumber',
  standalone: true
})
export class FaxNumberPipe implements PipeTransform {
  transform(faxNumber: string): string {
    
    faxNumber = (faxNumber?.length > 10 && faxNumber.charAt(0) == '1') ? faxNumber.slice(1) : faxNumber;
    if (FAX_NUMBER_FORMATTED_REGEXP.test(faxNumber)) {
      return faxNumber;
    }

    if (ONLY_DIGITS_REGEXP.test(faxNumber)) {
      return faxNumber.replace(FAX_NUMBER_MASK_REGEXP, FAX_NUMBER_FORMAT);
    }

    return EMPTY_VALUE;
  }
}
